module.exports = __webpack_public_path__ + "img/man-head-back.900c70b2.png";